// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-toggle{cursor:pointer;min-width:64px}.filter-toggle:hover>a{color:var(--color-sky-blue)}.filter-toggle:hover>svg{fill:var(--color-sky-blue)}.filter-toggle__text{display:inline;margin-right:5px;position:relative;top:2px}.filter-toggle__icon{display:inline;vertical-align:bottom}.filter-toggle__icon__left{margin:0 6px 0px 0px}", ""]);
// Exports
module.exports = exports;
